import type { CallRecord } from '../store/useCallStore';
import { FIELD_LABEL } from '../constants/fieldDefs';

function escape(val: unknown): string {
  const s = val === null || val === undefined ? '' : String(val);
  return s.includes(',') || s.includes('"') || s.includes('\n')
    ? `"${s.replace(/"/g, '""')}"`
    : s;
}

export function exportToCsv(calls: CallRecord[], columns: string[]): void {
  const headers = [
    ...columns.map((k) => FIELD_LABEL[k] ?? k),
    'Notiz',
    'Rückruf erledigt',
    'Erledigt von',
    'Erledigt um',
  ];

  const rows = calls.map((call) => [
    ...columns.map((k) => {
      const val = call[k];
      return escape(Array.isArray(val) ? `${(val as unknown[]).length} Einträge` : val);
    }),
    escape(call.callbackNote),
    escape(call.callbackDone ? 'Ja' : 'Nein'),
    escape(call.callbackBy),
    escape(call.callbackAt),
  ]);

  const csv = [headers.join(','), ...rows.map((r) => r.join(','))].join('\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `anrufhistorie_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
